import { ChangeDetectorRef, Component, inject, Input, model, ChangeDetectionStrategy } from "@angular/core";
import { DropDownItem } from "../../pojo/DropDownItem";
import { ServerSidePagination } from "../../pojo/ServerSidePagination";
import { BaseControlValueAccessor } from "../reactive-forms-control-value-accessor/base.control.value.accessor.directive";
import { FormValueControl } from "@angular/forms/signals";
import { Nullable } from "../../pojo/Util";
import { AriaLabel } from "../../util/aria/aria.label";

@Component({
    template: "",
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false,
})
export class S25DropdownAbstract<T extends string | number = string | number>
    extends BaseControlValueAccessor<DropDownItem<T>>
    implements FormValueControl<Nullable<DropDownItem<T>>>
{
    @Input() staticItems?: DropDownItem<T>[];
    @Input() onSelect?: (item: Nullable<DropDownItem>) => void;
    @Input() searchEnabled?: boolean;
    @Input() hasFav: boolean;
    @Input() autoOpen?: boolean;
    @Input() focusFirst?: boolean;
    @Input() alwaysOpen?: boolean;
    @Input() hideSearch?: boolean;
    @Input() apiBean?: any;
    @Input() serverSide?: ServerSidePagination; //only used for "expensive" search components (event, location, resource, org, contact, etc)
    @Input() resetSelectedOnCleanup: boolean;
    @Input() useSecurity?: boolean; //only used for master defn dropdowns
    @Input() activeOnly?: boolean; //only used for master defn dropdowns
    @Input() omitReadOnly?: boolean; //search criteria with 'tags' enabled might have a 'read only' option
    @Input() onLoad?: Function;
    @Input() customFilterValue: string;
    @Input() ariaLabel?: AriaLabel;
    @Input() noSelection?: string; // Show this message instead of the chosen item
    @Input() filter: (item: DropDownItem<T>) => boolean;
    @Input() emptyText: string;
    @Input() hasNoneItem: boolean = false;
    @Input() noneItemLabel: string = "None";
    @Input() scrollIntoView: boolean;
    @Input() readOnly: boolean;
    @Input() blockDetailsNav: boolean = false; // intentionally block ability to navigate to object details without OLS override in s25-item

    readonly cd = inject(ChangeDetectorRef);

    items: DropDownItem<T>[];
    readonly value = model<Nullable<DropDownItem<T>>>();

    constructor() {
        super();
    }

    onValueChange(data: any) {
        this.onTouched();
        this.onValChange(data);
        this.value.set(data ?? null);
    }

    onWriteValue(value: DropDownItem<T>) {
        this.value.set(value ?? null);
    }
}
